module.exports = __webpack_public_path__ + "node_modules/icheck/skins/minimal/red@2x.png?f1062c10";